
export default class RoutePlanningUtil {
    private options: any;
    private map: any;
    private _self: any;
    constructor(opts: any) {
        this._self = opts.context;
    }
    /**
     * 根据类型获取点symbol
     * @param iconClass
     */
    public _getPointSymbol(iconClass: any) {
        // tslint:disable-next-line: one-variable-per-declaration
        let symbol, source = '';
        switch (iconClass) {
            case 'preIcon startIcon':
                source = 'data:image/png;base64,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';
                break;
            case 'preIcon endIcon':
                source = 'data:image/png;base64,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';
                break;
            case 'preIcon stopIcon':
                source = 'data:image/png;base64,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';
                break;
        }
        symbol = new egis.sfs.PictureMarkerSymbol({
            source,
            width: '25', height: '40', rotation: '0', opacity: '1', offsetX: '13', offsetY: '40',
        });
        return symbol;
    }

    /**
     * 根据类型和位置获取点id
     * @param position
     * @param iconClass
     */
    public _getPointId(position: any, iconClass: any) {
        let id = position;
        switch (iconClass) {
            case 'preIcon startIcon':
                id = 'start';
                break;
            case 'preIcon endIcon':
                id = 'end';
                break;
            case 'preIcon stopIcon':
                id = 'middle' + id;
        }
        return id;
    }

    public parseRouteResult(result: any) {
        const data: any = {};
        const route = result.routes[0];
        data.length = route.distance;
        data.duration = route.duration;
        data.route = null;
        data.road = [];
        const lineString = new egis.sfs.LineString({
            spatialReference: this._self.map.spatialReference,
        });
        for (let i = 0, len = route.steps.length; i < len; i++) {
            const stepItem = route.steps[i];
            const roadItem: any = {};
            const strguide = stepItem.instruction + '';
            // strguide=strguide.replace(/\<b\>/g,'');
            // strguide=strguide.replace(/\<\/b\>/g,'');
            roadItem.strguide = strguide;
            roadItem.length = stepItem.distance;
            roadItem.direction = stepItem.direction * 30;
            const direction = stepItem.direction;
            // let direct = '';
            // if (direction === 0) {
            //     direct = '正北';
            // } else if (direction === 1 || direction === 2) {
            //     direct = '东北';
            // } else if (direction === 3) {
            //     direct = '正东';
            // } else if (direction === 4 || direction === 5) {
            //     direct = '东南';
            // } else if (direction === 6) {
            //     direct = '正南';
            // } else if (direction === 7 || direction === 8) {
            //     direct = '西南';
            // } else if (direction === 9) {
            //     direct = '正西';
            // } else if (direction === 10 || direction === 11) {
            //     direct = '西北';
            // }
            let directStr = '';
            if (i > 0) {
                if ((direction * 30 - data.road[i - 1].direction) > 10) {
                    directStr = '右转';
                } else if ((direction * 30 - data.road[i - 1].direction) < -10) {
                    directStr = '左转';
                } else {
                    directStr = '直行';
                }
            } else {
                directStr = '直行';
            }

            if (stepItem.traffic_condition) {
                roadItem.status = stepItem.traffic_condition[0].status;
            }
            roadItem.direct = directStr;
            roadItem.road = stepItem.path;
            roadItem.poly = stepItem.path;
            data.road.push(roadItem);
            for (const index of stepItem.path.points) {
                lineString.addPoint(index);
            }
        }
        data.route = lineString;
        return data;
    }

    public timeRound(time: any) {
        const minutes = time / 60;
        let timeLabel = '';
        if (minutes < 60) {
            timeLabel = Math.round(minutes).toString() + '分钟';
        } else if (minutes >= 60) {
            const hour = minutes / 60;
            timeLabel = Math.round(hour).toString() + '小时';
        }
        return timeLabel;
    }
    public onRouteResult(data: any) {
        this._self.roadInfo = data.road;
        this._self.routeLayers.clear();
        this._self.toolTipWare.clear();
        let color = '';
        for (let i = 0; i < data.road.length; i++) {
            const item = data.road[i];
            if (item.status || item.status === 0) {
                const color_ = this._self.options.router.state[item.status];
                color = egis.sfs.Color.fromHex(color_);
                // color_.a = 170;
            } else {
                color = new egis.sfs.Color({ a: 255, r: 82, g: 152, b: 255 });
            }
            const pathSymbol = new egis.sfs.SimpleLineSymbol({
                width: 7,
                color,
                style: 5,
            });
            const roadPathEle = new egis.sfs.Element({ geometry: item.road, symbol: pathSymbol });
            this._self.routeLayers.add(roadPathEle);
        }
        this._self.map.pan(data.route);
    }

    /**
     * 逆向地理编码
     * @param params
     */
    public request2(params: any) {
        return new Promise((resolve, reject) => {
            const WRGSInput = new egis.ews.WRGSInput({
                location: [params.x, params.y].join(','),
            });
            this._self.WRGSService.regeocode(WRGSInput).then((result: any) => {
                const data: any = {};
                data.x = result.location.x;
                data.y = result.location.y;
                data.address = result.formatted_address;
                resolve(data);
            });
        });
    }

    public clearRouteResults() {
        this._self.routeLayers.clear();
        this._self.options.midPointFlag = false;
        if (this._self.toolTipWare) { this._self.toolTipWare.clear(); }
        if (this._self.highlightLayer) { this._self.highlightLayer.clear(); }
    }

    public calAreaByExtent(extent: any) {
        const ring = new egis.sfs.Ring({ spatialReference: this._self.map.spatialReference });
        ring.addPoint(new egis.sfs.Point({ x: extent.minx, y: extent.miny, spatialReference: this._self.map.spatialReference }));
        ring.addPoint(new egis.sfs.Point({ x: extent.minx, y: extent.maxy, spatialReference: this._self.map.spatialReference }));
        ring.addPoint(new egis.sfs.Point({ x: extent.maxx, y: extent.maxy, spatialReference: this._self.map.spatialReference }));
        ring.addPoint(new egis.sfs.Point({ x: extent.maxx, y: extent.miny, spatialReference: this._self.map.spatialReference }));
        ring.addPoint(new egis.sfs.Point({ x: extent.minx, y: extent.miny, spatialReference: this._self.map.spatialReference }));
        const polygon = new egis.sfs.Polygon({ spatialReference: this._self.map.spatialReference });
        polygon.addGeometry(ring);
        const area = polygon.area();
        return area;
    }

    public locateToPoint(x: any, y: any, zoom: any) {
        this._self.map.zoomTo(zoom);
        this._self.map.setCenter(new egis.sfs.Point({
            x,
            y,
            spatialReference: this._self.map.spatialReference,
        }));
    }

    // 解析公交结果显示在地图上
    public showRoute_bus(result: any, num: any) {
        // console.log(JSON.stringify(result));
        console.log(result);
        const route = result.routes[num];
        const steps = route.steps;
        this.showBusRoute(steps);
    }
    // 显示指定公交路线
    public showBusRoute(steps: any) {
        this._self.routeLayers.clear();
        this._self.toolTipWare.clear();
        this._self.highlightLayer.clear();
        const geoList = [];
        for (let i = 0; i < steps.length; i++) {
            if (steps[i].schemes[0].instruction) {
                for (let n = 0; n < steps[i].schemes.length; n++) {
                    const schema = steps[i].schemes[n];
                    const path = schema.path;
                    geoList.push(path);
                    this.showBusRouteStop(schema);
                }
            } else {
                this.showBusSeparateRoutes(steps[i].schemes);
                for (let m = 0; m < steps[i].schemes.length; m++) {
                    const schema = steps[i].schemes[m];
                    const path = schema.path;
                    geoList.push(path);
                }
            }
        }
        const geoArr = G.utils.GeometryUtil.getGeometryEnvlop(geoList);
        this._self.map.pan(geoArr);
    }

    private panToGeoCollection(geoList: any) {
        const geoArr = G.utils.GeometryUtil.getGeometryEnvlop(geoList);
        this.map.pan(geoArr);
    }

    // 显示公交线路和站点及弹窗
    private showBusRouteStop(schema: any) {
        const vehicle_info = schema.vehicle_info;
        const colorRamp = this._self.options.symbolConfig.symbols.pathAnalysis.busPathColor;
        if (vehicle_info.type !== 5) {
            // console.log(schema.instruction + "，非步行 开始绘制");
            const time = schema.duration;
            const time_round = this.timeRound(time);
            const contentTemplate = '<div class="compMap-znGeocoding-map-panel" style="padding: 3px;"><label>' + '乘坐' + vehicle_info.detail.name + '</br>' + '车程约' + time_round + '</br>' + '</label></div>';
            let symbol;
            switch (vehicle_info.type) {
                case 1: // 火车
                    symbol = new egis.sfs.PictureMarkerSymbol(this._self.options.symbolConfig.symbols.pathAnalysis.trainStop);
                    break;
                case 2: // 飞机
                    symbol = new egis.sfs.PictureMarkerSymbol(this._self.options.symbolConfig.symbols.pathAnalysis.planeStop);
                    break;
                case 3: // 公交
                case 6: // 大巴
                    symbol = new egis.sfs.PictureMarkerSymbol(this._self.options.symbolConfig.symbols.pathAnalysis.busStop);
                    break;
                default:
                    symbol = new egis.sfs.SimpleMarkerSymbol({
                        size: 9,
                        offsetX: 0,
                        offsetY: 0,
                        fillColor: new egis.sfs.Color({ a: 255, r: 43, g: 230, b: 34 }),
                    });
                    break;
            }
            const ele = new egis.sfs.Element({
                geometry: schema.start_location,
                symbol,
            });
            this._self.routeLayers.add(ele);
            const tooltip = new egis.widget.Tooltip({
                anchor: schema.start_location,     // 提示在地图上停靠位置
                content: contentTemplate,  // 提示内容
                layerId: this._self.routeLayers.getLayerId(), // 提示所在图层ID
                offset: [20, 0],     // 位置偏移量
                className: 'egis-tooltip',  // tooltip样式
            });
            this._self.toolTipWare.add(tooltip);
        }
        const path = schema.path;
        const num = Math.round((colorRamp.length - 1) * Math.random()) || 0;
        const color = egis.sfs.Color.fromHex(colorRamp[num]);
        const pathSymbol = new egis.sfs.SimpleLineSymbol({
            width: 8,
            color, // new egis.sfs.Color({a: 255, r: Math.ceil(180*Math.random()), g: Math.ceil(180*Math.random()), b: Math.ceil(180*Math.random())})
            style: 5,
        });
        const roadPathEle = new egis.sfs.Element({ geometry: path, symbol: pathSymbol });
        this._self.routeLayers.add(roadPathEle);
    }

    /**
     * 绘制散段路线
     * @param schemes
     */
    private showBusSeparateRoutes(schemes: any) {
        const colorRamp = this._self.options.symbolConfig.symbols.pathAnalysis.busPathColor;
        const num = Math.round((colorRamp.length - 1) * Math.random()) || 0;
        const color = egis.sfs.Color.fromHex(colorRamp[num]);
        const pathSymbol = new egis.sfs.SimpleLineSymbol({
            width: 8,
            color,
            style: 5,
        });

        for (let m = 0; m < schemes.length; m++) {
            const schema = schemes[m];
            const path = schema.path;
            const roadPathEle = new egis.sfs.Element({ geometry: path, symbol: pathSymbol });
            this._self.routeLayers.add(roadPathEle);
        }
    }

}
